import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "manasvi_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthed = () => !!getToken();

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const CLINIC = {
  name: "Manasvi Dental Clinic",
  tagline: "Premium Dental Care in Kota",
  doctor: "Dr. Deepika Charan",
  doctorCred: "BDS, MIDA (Oro-Dental Surgeon) — Certified Implantologist & Orthodontist",
  address: "34E, Shreenathpuram E, Near Hadi Rani Circle & Sheetla Prasad Community Hall, Kota - 324010",
  phone: "+91 75976 95987",
  email: "info@manasvidental.com",
  hours: "Mon–Sat: 9 AM – 2 PM & 5 PM – 8 PM • Sun: 9 AM – 2 PM (Evening closed)",
  mapSrc: "https://www.google.com/maps?q=Shreenathpuram+E+Hadi+Rani+Circle+Sheetla+Prasad+Community+Hall+Kota+324010&output=embed",
  logo: "/logo.png",
};
